import React from 'react';
type SectionHeadingProps = {
  id: string;
  title: string;
  eyebrow?: string;
  intro?: string;
  tone?: 'light' | 'dark';
  align?: 'center' | 'left';
};
export function SectionHeading({
  id,
  title,
  eyebrow,
  intro,
  tone = 'light',
  align = 'center'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  const alignClasses = align === 'center' ? 'mx-auto text-center' : 'text-left';
  return <div className={`max-w-3xl ${alignClasses}`} data-id="element-159" data-mp="bk3q5rowh9bi">
      {eyebrow && <p className={`text-[13px] font-semibold uppercase tracking-[0.14em] ${isDark ? 'text-sage' : 'text-forest'}`} data-id="element-160" data-mp="gj6v7c4vrfjh">
          {eyebrow}
        </p>}
      <h2 id={id} className={`font-serif text-[clamp(2rem,4.2vw,3.125rem)] font-medium leading-[1.1] ${eyebrow ? 'mt-4' : ''} ${isDark ? 'text-ivory' : 'text-charcoal'}`} data-id="element-161" data-mp="1spszqkf8llj">
        {title}
      </h2>
      {intro && <p className={`mt-5 text-base leading-relaxed md:text-lg ${isDark ? 'text-ivory/80' : 'text-charcoal/75'}`} data-id="element-162" data-mp="za7phmv22mwp">
          {intro}
        </p>}
    </div>;
}